import BaseClient from "./BaseClient";

export default class FeeServiceClient extends BaseClient {
    constructor(billingDate = null, tenantId: string) {
        super(billingDate, tenantId, true, "ams");
    }

    public async createFee(accountId: string, feeName: string, feeAmount: number, quantity: number) {
        let body = {
            name: feeName,
            amount: null,
            quantity: null
        };

        if (feeAmount)
            body.amount = { value: feeAmount }

        if(quantity)
            body.quantity = quantity

        const response = await this.post(`/api/proxy/ams/fee-service/account/${accountId}/fees`, body);

        return await this.handleResponse(response);
    }

    public async reverseTransaction(accountId: string, transactionId: string) { 
        const response = await this.post(`/api/proxy/ams/fee-service/account/${accountId}/fees/transaction/${transactionId}/reverse`, {});
        return await this.handleResponse(response);
    }
}

export const useFeeService = (billingDate = null, tenantId: string): FeeServiceClient => {
    return new FeeServiceClient(billingDate, tenantId);
};